import useModalContext from '@hooks/context/useModalContext';
import { modalIds } from '@const/modals';

interface TApproveModalProps {
    cancelLabel: string;
    confirmLabel: string;
    title: string;
    description: string;
    onSubmit: () => void;
}

export const useGlobalModals = () => {
    const { onOpen, handleChangeModalState, changeModalData } = useModalContext();
    const handleOpenApproveActionModal = ({
        cancelLabel,
        confirmLabel,
        title,
        description,
        onSubmit
    }: TApproveModalProps) => {
        handleChangeModalState({
            confirmLabel,
            cancelLabel
        });
        changeModalData({
            title,
            description
        });
        onOpen({
            modalId: modalIds.APPROVE_ACTION,
            onSubmit: onSubmit
        });
    };

    return {
        handleOpenApproveActionModal
    };
};
